import { SchemaFactory } from 'fluid-framework';
export const schemaFactory = new SchemaFactory('datapad.calendar');
//# sourceMappingURL=Factory.js.map